import { createSystem, defaultConfig } from '@chakra-ui/react';

// Production and all browser/component fixtures must use the same CSS baseline.
export const system = createSystem(defaultConfig, { preflight: false });
